import {
    login,
    logout,
    getInfo,
    get_show_logo
} from '@/api/user'
import {
    getToken,
    getUserid,
    getType,
    setToken,
    setType,
    setUserid,
    removeToken,


} from '@/utils/auth'
import router, {
    resetRouter
} from '@/router'

const state = {
    token: getToken(),
    userid: getUserid(),
    type: getType(),
    plan_id: 0,
    form_id: 0,
    is_higher_school: '',
    video_id: 0,
    institution_id: 0,
    institution: {},
    name: '',
    avatar: '',
    username: '',
    nickname: '',
    mobile: '',
    department: '',
    department_id: '',
    introduction: '',
    roles: [],
    admin_menu_paths: [],
    admin_role_ids: [],
    show_logo: '',
    modal: true,
    buyer_id: '',
}

const mutations = {
    SET_IS_HIGHER_SCHOOL: (state, school) => {
        state.is_higher_school = school
    },
    SET_video_id: (state, video_id) => {
        state.video_id = video_id
    },
    SET_modal(state, modal) {
        state.modal = modal
            // console.log(state)
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_USERNAME: (state, username) => {
        state.username = username
    },
    SET_NICKNAME: (state, nickname) => {
        state.nickname = nickname
    },
    SET_MOBILE: (state, mobile) => {
        state.mobile = mobile
    },
    SET_BUYERID: (state, buyer_id) => {
        state.buyer_id = buyer_id
    },
    SET_DEPARTMENT: (state, department) => {
        state.department = department
    },
    SET_DEPARTMENT_ID: (state, department_id) => {
        state.department_id = department_id
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_USERID: (state, userid) => {
        state.userid = userid
    },
    SET_type: (state, type) => {
        state.type = type
    },
    SET_PLANID: (state, pid) => {
        state.plan_id = pid
    },
    SET_FORMID: (state, fid) => {
        state.form_id = fid
    },
    SET_INSTITUTION_ID: (state, iid) => {
        state.institution_id = iid
    },
    SET_INSTITUTION: (state, tion) => {
        state.institution = tion
    },
    SET_ADMIN_MENU_PATHS: (state, menuPaths) => {
        state.admin_menu_paths = menuPaths
    },
    SET_ADMIN_ROLE_IDS: (state, menuPaths) => {
        state.admin_role_ids = menuPaths
    },
    SET_SHOW_LOGO: (state, show_logo) => {
        state.show_logo = show_logo
    },


}

const actions = {
    setNewToken({
        commit
    }, datas) {
        commit('SET_TOKEN', datas)
        setToken(datas)
        if (datas) {
            return 'ok'
        } else {
            return 'no'
        }
    },
    setPlanId({
        commit
    }, datas) {
        commit('SET_PLANID', datas)
        if (datas) {
            return 'ok'
        } else {
            return 'no'
        }
    },
    // user login 123
    login({
        commit
    }, userInfo) {
        const {
            username,
            nickname,
            mobile,
            password,
            verify_id,
            verify_code
        } = userInfo
        return new Promise((resolve, reject) => {
            login({
                username: username,
                nickname: nickname,
                mobile: mobile,
                password: password,
                verify_id: verify_id,
                verify_code: verify_code
            }).then(response => {
                const {
                    data
                } = response
                localStorage.setItem("last_login_time", data.last_login_time);
                commit('SET_IS_HIGHER_SCHOOL', data.is_higher_school)
                commit('SET_USERID', data.id)
                commit('SET_type', data.type)
                commit('SET_video_id', data.video_id)
                setUserid(data.id)
                setType(data.type)
                if (data.is_higher_school) {
                    localStorage.setItem('myToken', data.admin_token)
                    window.location.replace(window.location.origin + window.location.pathname + "#/goHightSchool")
                } else {
                    commit('SET_TOKEN', data.admin_token)
                    setToken(data.admin_token)
                }
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // get user info
    getInfo({
        commit,
        state
    }) {
        return new Promise((resolve, reject) => {
            getInfo(state.token).then(response => {
                const {
                    data
                } = response
                if (!data) {
                    reject('Verification failed, please Login again.')
                }

                const {
                    admin_menu_paths,
                    admin_role_ids,
                    username,
                    mobile,
                    id,
                    department,
                    department_id,
                    nickname,
                    avatar,
                    introduction,
                    select_plan_id,
                    select_form_id,
                    institution_id,
                    institution,
                } = data
                if (id != 1) {
                    // roles must be a non-empty array
                    if ((!admin_menu_paths || admin_menu_paths.length <= 0)) {

                        reject('getInfo: roles must be a non-null array!')
                    } else {
                        commit('SET_ROLES', admin_menu_paths)
                    }
                } else {
                    commit('SET_ROLES', ['admin'])
                }

                commit('SET_BUYERID', id)
                commit('SET_DEPARTMENT', department)
                commit('SET_MOBILE', mobile)
                commit('SET_DEPARTMENT_ID', department_id)
                commit('SET_USERNAME', username || nickname)
                commit('SET_NICKNAME', nickname || nickname)
                commit('SET_AVATAR', avatar)
                commit('SET_INTRODUCTION', introduction)
                commit('SET_PLANID', select_plan_id)
                commit('SET_FORMID', select_form_id)
                commit('SET_INSTITUTION_ID', institution_id)
                commit('SET_INSTITUTION', institution)
                commit('SET_ADMIN_MENU_PATHS', admin_menu_paths)
                commit('SET_ADMIN_ROLE_IDS', admin_role_ids)
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // user logout
    logout({
        commit,
        state,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            logout(state.token).then(() => {
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                removeToken()
                resetRouter()

                // reset visited views and cached views
                // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
                dispatch('tagsView/delAllViews', null, {
                    root: true
                })

                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // remove token
    resetToken({
        commit
    }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            resolve()
        })
    },
    // dynamically modify permissions
    async changeRoles({
        commit,
        dispatch
    }, role) {
        const token = role + '-token'

        commit('SET_TOKEN', token)
        setToken(token)

        const {
            roles
        } = await dispatch('getInfo')

        resetRouter()

        // generate accessible routes map based on roles
        const accessRoutes = await dispatch('permission/generateRoutes', roles, {
                root: true
            })
            // dynamically add accessible routes
        router.addRoutes(accessRoutes)

        // reset visited views and cached views
        dispatch('tagsView/delAllViews', null, {
            root: true
        })
    },

    get_show_logo({
        commit
    }, name) {
        return new Promise((resolve, reject) => {
            get_show_logo({
                name
            }).then(response => {
                const {
                    data
                } = response
                commit('SET_SHOW_LOGO', data)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}